import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';
import { type Variant, variantClass } from '@/styles/colors/variants';

export const Badge = (
  props: HTMLAttributes<HTMLDivElement> & {
    variant?: Variant;
  },
) => {
  const { children, className, variant = 'default', ...rest } = props;

  return (
    <div
      className={cn(
        'inline-flex items-center px-1.5 py-0.5 gap-2 text-[13px] font-medium rounded-sm border h-fit min-w-0',
        variantClass[variant],
        className,
      )}
      {...rest}
    >
      <span className="truncate line-clamp-1">{props.children}</span>
    </div>
  );
};
